import { render, staticRenderFns } from "./ProjectsViewCard.vue?vue&type=template&id=df8cde0c"
import script from "./ProjectsViewCard.vue?vue&type=script&lang=js"
export * from "./ProjectsViewCard.vue?vue&type=script&lang=js"
import style0 from "./ProjectsViewCard.vue?vue&type=style&index=0&id=df8cde0c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports